import type { Language } from "../../contexts/LanguageContext";

export const clientDetailsLabels: Record<Language, {
  editPage: {
    title: string;
    back: string;
    loading: string;
    invalid: string;
    notFound: string;
    sections: {
      personal: {
        title: string;
        name: string;
        birthDate: string;
        gender: string;
        cpf: string;
        phone: string;
        email: string;
        emergencyContact: string;
        emergencyPhone: string;
      };
      address: {
        title: string;
        zip: string;
        street: string;
        addressNumber: string;
        complement: string;
        neighborhood: string;
        city: string;
        state: string;
      };
      insurance: {
        title: string;
        insurance: string;
        plan: string;
        cardNumber: string;
      };
    };
    actions: {
      cancel: string;
      save: string;
      saving: string;
    };
  };
  paymentsSection: {
    title: string;
    empty: string;
    columns: {
      date: string;
      amount: string;
      status: string;
      plan: string;
      actions: string;
    };
    status: {
      paid: string;
      pending: string;
    };
    planFallback: string;
    actions: {
      markAsPaid: string;
      markingAsPaid: string;
      moreActions: string;
      editDue: string;
      unmarkPayment: string;
      delete: string;
      openPlan: string;
    };
    dialogs: {
      editDue: {
        title: string;
        close: string;
        dateLabel: string;
        timeLabel: string;
        cancel: string;
        save: string;
      };
      delete: {
        title: string;
        description: string;
        confirm: string;
        cancel: string;
      };
    };
  };
   historySection: {
     title: string;
     empty: string;
     pendingEvolution: string;
     fillEvolution: string;
     loading: string;
   };
   timelineSection: {
     title: string;
     empty: string;
     inputPlaceholder: string;
     postButton: string;
     selectType: string;
     types: {
       note: string;
       call: string;
       document: string;
       other: string;
     };
     toasts: {
       success: string;
       error: string;
     };
   };
  upcomingSection: {
    title: string;
    defaultTitle: string;
    minutes: string;
  };
  metricsSection: {
    title: string;
    lastMonth: string;
    lastQuarter: string;
    lastSemester: string;
    lastYear: string;
    appointments: string;
  };
  contractsSection: {
    title: string;
    empty: string;
    generateButton: string;
    columns: {
      title: string;
      status: string;
      date: string;
      actions: string;
    };
    status: {
      pending: string;
      signed: string;
      rejected: string;
      canceled: string;
    };
  };
  detailPage: {
    header: string;
    infoTitle: string;
    editButton: string;
    loading: string;
    sections: {
      personal: string;
      address: string;
      insurance: string;
    };
    labels: {
      name: string;
      phone: string;
      email: string;
      birthDate: string;
      cpf: string;
      gender: string;
      emergencyContact: string;
      emergencyPhone: string;
      zip: string;
      street: string;
      number: string;
      complement: string;
      neighborhood: string;
      city: string;
      state: string;
      insurance: string;
      plan: string;
      cardNumber: string;
    };
  };
  recurringPlansSection: {
    title: string;
    showInactive: string;
    empty: string;
    inactiveBadge: string;
    downloadContract: string;
    cancelContract: string;
    copyLink: string;
    linkCopied: string;
    deleteContract: string;
    generateContract: string;
    errors: {
      fetchTemplate: string;
      noTemplate: string;
      generateFailed: string;
    };
    toasts: {
      generated: string;
    };
    confirms: {
      deleteSigned: string;
      deletePending: string;
    };
  };
  deleteDialog: {
    button: string;
    title: string;
    description: string;
    cancel: string;
    confirm: string;
  };
  noteModal: {
    title: string;
    audio: {
      title: string;
      subtitle: string;
      buttonStart: string;
      recording: string;
      buttonStop: string;
      converting: string;
    };
    content: {
      label: string;
      improve: string;
      improving: string;
      placeholder: string;
    };
    actions: {
      cancel: string;
      save: string;
    };
    toasts: {
      success: string;
      error: string;
      audioConverted: string;
      audioError: string;
      aiError: string;
    };
  };
}> = {
  pt: {
    editPage: {
      title: "Editar cliente",
      back: "Voltar",
      loading: "Carregando...",
      invalid: "Cliente inválido",
      notFound: "Cliente não encontrado",
      sections: {
        personal: {
          title: "Informações pessoais",
          name: "Nome",
          birthDate: "Nascimento",
          gender: "Gênero",
          cpf: "CPF",
          phone: "Telefone",
          email: "E-mail",
          emergencyContact: "Contato de emergência",
          emergencyPhone: "Telefone de emergência",
        },
        address: {
          title: "Endereço",
          zip: "CEP",
          street: "Logradouro",
          addressNumber: "Número",
          complement: "Complemento",
          neighborhood: "Bairro",
          city: "Cidade",
          state: "UF",
        },
        insurance: {
          title: "Convênio",
          insurance: "Convênio",
          plan: "Plano",
          cardNumber: "Carteirinha",
        },
      },
      actions: {
        cancel: "Cancelar",
        save: "Salvar",
        saving: "Salvando...",
      },
    },
    paymentsSection: {
      title: "Histórico de pagamentos",
      empty: "Nenhum pagamento registrado.",
      columns: {
        date: "Data",
        amount: "Valor",
        status: "Status",
        plan: "Plano",
        actions: "Ações",
      },
      status: {
        paid: "Pago",
        pending: "Em aberto",
      },
      planFallback: "—",
      actions: {
        markAsPaid: "Marcar como pago",
        markingAsPaid: "Salvando...",
        moreActions: "Mais ações",
        editDue: "Editar vencimento",
        unmarkPayment: "Desmarcar pagamento",
        delete: "Excluir",
        openPlan: "Abrir detalhes do plano",
      },
      dialogs: {
        editDue: {
          title: "Editar vencimento",
          close: "Fechar",
          dateLabel: "Data",
          timeLabel: "Hora",
          cancel: "Cancelar",
          save: "Salvar",
        },
        delete: {
          title: "Excluir pagamento",
          description: "Essa ação não pode ser desfeita. Tem certeza que deseja excluir o pagamento?",
          confirm: "Excluir",
          cancel: "Cancelar",
        },
      },
    },
     historySection: {
       title: "Histórico de consultas",
       empty: "Nenhuma consulta realizada.",
       pendingEvolution: "Evolução pendente",
       fillEvolution: "Preencher evolução",
       loading: "Carregando...",
    },
     timelineSection: {
       title: "Linha do Tempo",
       empty: "Nenhum evento registrado.",
       inputPlaceholder: "Escreva uma atualização sobre o paciente...",
       postButton: "Registrar",
       selectType: "Tipo",
       types: {
         note: "Nota",
         call: "Contato Telefônico",
         document: "Documento",
         other: "Outro"
       },
       toasts: {
         success: "Registro salvo com sucesso!",
         error: "Erro ao salvar registro."
       }
    },
     upcomingSection: {
      title: "Próximas Consultas",
      defaultTitle: "Consulta",
      minutes: "min",
    },
    metricsSection: {
      title: "Métricas de atendimento",
      lastMonth: "Último mês",
      lastQuarter: "Último trimestre",
      lastSemester: "Último semestre",
      lastYear: "Último ano",
      appointments: "consultas",
    },
    contractsSection: {
      title: "Contratos e Documentos",
      empty: "Nenhum contrato gerado para este cliente.",
      generateButton: "Gerar Novo Contrato",
      columns: {
        title: "Documento",
        status: "Status",
        date: "Data",
        actions: "Ações",
      },
      status: {
        pending: "Aguardando Assinatura",
        signed: "Assinado",
        rejected: "Recusado",
        canceled: "Cancelado",
      },
    },
    detailPage: {
      header: "Cliente",
      infoTitle: "Informações gerais",
      editButton: "Editar cliente",
      loading: "Carregando...",
      sections: {
        personal: "Informações pessoais",
        address: "Informações de residência",
        insurance: "Convênio",
      },
      labels: {
        name: "Nome",
        phone: "Telefone",
        email: "E-mail",
        birthDate: "Nascimento",
        cpf: "CPF",
        gender: "Gênero",
        emergencyContact: "Contato de emergência",
        emergencyPhone: "Telefone de emergência",
        zip: "CEP",
        street: "Rua",
        number: "Número",
        complement: "Complemento",
        neighborhood: "Bairro",
        city: "Cidade",
        state: "Estado",
        insurance: "Convênio",
        plan: "Plano",
        cardNumber: "Carteirinha",
      },
    },
    recurringPlansSection: {
      title: "Planos recorrentes",
      showInactive: "Mostrar inativos",
      empty: "Nenhum plano encontrado.",
      inactiveBadge: "Inativo",
      downloadContract: "Baixar Contrato",
      cancelContract: "Cancelar Contrato",
      copyLink: "Copiar link do contrato",
      linkCopied: "Link copiado!",
      deleteContract: "Apagar Contrato",
      generateContract: "Gerar Contrato",
      errors: {
        fetchTemplate: "Erro ao buscar template",
        noTemplate: "Nenhum template configurado",
        generateFailed: "Erro ao gerar",
      },
      toasts: {
        generated: "Contrato gerado!",
      },
      confirms: {
        deleteSigned: "Deseja cancelar/apagar este contrato assinado?",
        deletePending: "Deseja apagar este contrato pendente?",
      },
    },
    deleteDialog: {
      button: "Excluir cliente",
      title: "Excluir cliente",
      description: "Tem certeza que deseja excluir o cliente \"{{name}}\"? Esta ação não pode ser desfeita.",
      cancel: "Cancelar",
      confirm: "Excluir",
    },
    noteModal: {
      title: "Nova Nota do Paciente",
      audio: {
        title: "Gravar nota por voz",
        subtitle: "Fale e a IA transcreve para você",
        buttonStart: "Começar",
        recording: "Gravando...",
        buttonStop: "Parar",
        converting: "Convertendo áudio em texto...",
      },
      content: {
        label: "Conteúdo da Nota",
        improve: "Melhorar com IA",
        improving: "Melhorando...",
        placeholder: "Escreva sua nota aqui ou use a gravação por voz acima...",
      },
      actions: {
        cancel: "Cancelar",
        save: "Salvar Nota",
      },
      toasts: {
        success: "Nota salva com sucesso!",
        error: "Erro ao salvar nota",
        audioConverted: "Áudio convertido!",
        audioError: "Erro na conversão de áudio",
        aiError: "Erro ao usar IA",
      },
    },
  },
  en: {
    editPage: {
      title: "Edit client",
      back: "Back",
      loading: "Loading...",
      invalid: "Invalid client",
      notFound: "Client not found",
      sections: {
        personal: {
          title: "Personal information",
          name: "Name",
          birthDate: "Birth date",
          gender: "Gender",
          cpf: "CPF",
          phone: "Phone",
          email: "Email",
          emergencyContact: "Emergency contact",
          emergencyPhone: "Emergency phone",
        },
        address: {
          title: "Address",
          zip: "ZIP",
          street: "Street",
          addressNumber: "Number",
          complement: "Complement",
          neighborhood: "Neighborhood",
          city: "City",
          state: "State",
        },
        insurance: {
          title: "Insurance",
          insurance: "Insurance",
          plan: "Plan",
          cardNumber: "Card number",
        },
      },
      actions: {
        cancel: "Cancel",
        save: "Save",
        saving: "Saving...",
      },
    },
    paymentsSection: {
      title: "Payment history",
      empty: "No payments yet.",
      columns: {
        date: "Date",
        amount: "Amount",
        status: "Status",
        plan: "Plan",
        actions: "Actions",
      },
      status: {
        paid: "Paid",
        pending: "Pending",
      },
      planFallback: "—",
      actions: {
        markAsPaid: "Mark as paid",
        markingAsPaid: "Saving...",
        moreActions: "More actions",
        editDue: "Edit due date",
        unmarkPayment: "Undo payment",
        delete: "Delete",
        openPlan: "Open plan details",
      },
      dialogs: {
        editDue: {
          title: "Edit due date",
          close: "Close",
          dateLabel: "Date",
          timeLabel: "Time",
          cancel: "Cancel",
          save: "Save",
        },
        delete: {
          title: "Delete payment",
          description: "This action cannot be undone. Are you sure you want to delete this payment?",
          confirm: "Delete",
          cancel: "Cancel",
        },
      },
    },
     historySection: {
       title: "Consultation history",
       empty: "No consultations yet.",
       pendingEvolution: "Pending evolution",
       fillEvolution: "Fill evolution",
       loading: "Loading...",
    },
     timelineSection: {
       title: "Timeline",
       empty: "No events yet.",
       inputPlaceholder: "Write an update about the patient...",
       postButton: "Post",
       selectType: "Type",
       types: {
         note: "Note",
         call: "Phone Call",
         document: "Document",
         other: "Other"
       },
       toasts: {
         success: "Event registered successfully!",
         error: "Error saving event."
       }
    },
     upcomingSection: {
      title: "Upcoming Appointments",
      defaultTitle: "Appointment",
      minutes: "min",
    },
    metricsSection: {
      title: "Attendance metrics",
      lastMonth: "Last month",
      lastQuarter: "Last quarter",
      lastSemester: "Last semester",
      lastYear: "Last year",
      appointments: "appointments",
    },
    contractsSection: {
      title: "Contracts & Documents",
      empty: "No contracts generated for this client.",
      generateButton: "Generate New Contract",
      columns: {
        title: "Document",
        status: "Status",
        date: "Date",
        actions: "Actions",
      },
      status: {
        pending: "Waiting for Signature",
        signed: "Signed",
        rejected: "Rejected",
        canceled: "Canceled",
      },
    },
    detailPage: {
      header: "Client",
      infoTitle: "General information",
      editButton: "Edit client",
      loading: "Loading...",
      sections: {
        personal: "Personal information",
        address: "Residence information",
        insurance: "Insurance",
      },
      labels: {
        name: "Name",
        phone: "Phone",
        email: "Email",
        birthDate: "Birth date",
        cpf: "CPF",
        gender: "Gender",
        emergencyContact: "Emergency contact",
        emergencyPhone: "Emergency phone",
        zip: "ZIP",
        street: "Street",
        number: "Number",
        complement: "Complement",
        neighborhood: "Neighborhood",
        city: "City",
        state: "State",
        insurance: "Insurance",
        plan: "Plan",
        cardNumber: "Card number",
      },
    },
    recurringPlansSection: {
      title: "Recurring Plans",
      showInactive: "Show inactive",
      empty: "No plans found.",
      inactiveBadge: "Inactive",
      downloadContract: "Download Contract",
      cancelContract: "Cancel Contract",
      copyLink: "Copy contract link",
      linkCopied: "Link copied!",
      deleteContract: "Delete Contract",
      generateContract: "Generate Contract",
      errors: {
        fetchTemplate: "Error fetching template",
        noTemplate: "No template configured",
        generateFailed: "Failed to generate",
      },
      toasts: {
        generated: "Contract generated!",
      },
      confirms: {
        deleteSigned: "Cancel/Delete this signed contract?",
        deletePending: "Delete this pending contract?",
      },
    },
    deleteDialog: {
      button: "Delete client",
      title: "Delete client",
      description: "Are you sure you want to delete client \"{{name}}\"? This action cannot be undone.",
      cancel: "Cancel",
      confirm: "Delete",
    },
    noteModal: {
      title: "New Patient Note",
      audio: {
        title: "Voice Record Note",
        subtitle: "Speak and AI will transcribe for you",
        buttonStart: "Start",
        recording: "Recording...",
        buttonStop: "Stop",
        converting: "Converting audio to text...",
      },
      content: {
        label: "Note Content",
        improve: "Improve with AI",
        improving: "Improving...",
        placeholder: "Write your note here or use voice recording above...",
      },
      actions: {
        cancel: "Cancel",
        save: "Save Note",
      },
      toasts: {
        success: "Note saved successfully!",
        error: "Error saving note",
        audioConverted: "Audio converted!",
        audioError: "Audio conversion error",
        aiError: "AI error",
      },
    },
  },
};
